module.exports = __webpack_public_path__ + "static/media/power_performance_comparative_per_month.05fda58c.svg";